/**
 * Base URL for tee-swap-api (must include `/api` path prefix used by Express).
 * Example: http://localhost:3001/api — must match `PORT` and `routePrefix` in the API.
 */
function normalizeApiBaseUrl(raw: string | undefined): string {
  const fallback = 'http://localhost:3001/api'
  const trimmed = raw?.trim()
  if (!trimmed) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn(
        `[configs] REACT_APP_API_URL is missing; using ${fallback}. Add it to tee-swap-admin/.env`
      )
    }
    return fallback
  }
  return trimmed.replace(/\/+$/, '')
}

export const API_URL = normalizeApiBaseUrl(process.env.REACT_APP_API_URL)
